export const GET_ITEM_CONDITIONS = 'GET_ITEM_CONDITIONS';
export const FLAG_GETTING_ITEM_CONDITIONS = 'FLAG_GETTING_ITEM_CONDITIONS';
export const CLEAR_ITEM_CONDITIONS = 'CLEAR_ITEM_CONDITIONS';